up.FocusCapsule = class FocusCapsule {
    constructor(element, target) {
        this._element = element;
        this._target = target;
        this._cursorProps = up.viewport.copyCursorProps(this._element);
    }
    wasLost() {
        return document.activeElement !== this._element && !this._voided;
    }
    autoVoid() {
        up.on('focusin', { once: true }, () => this._voided = true);
    }
    restore(layer, focusOptions) {
        if (!this.wasLost()) {
            return false;
        }
        let rediscoveredElement = up.fragment.get(this._target, { layer });
        if (rediscoveredElement) {
            up.viewport.copyCursorProps(this._cursorProps, rediscoveredElement);
            up.focus(rediscoveredElement, focusOptions);
            return true;
        }
    }
    static preserve(layer) {
        let focusedElement = up.viewport.focusedElementWithin(layer.element);
        if (!focusedElement)
            return;
        let target = up.fragment.tryToTarget(focusedElement);
        if (!target)
            return;
        return new this(focusedElement, target);
    }
};
